import * as vp from 'vopay';

type PersonalProfileRows = {
  label: vp.PersonalProfileLabel;
  id: vp.PersonalProfileId;
  required: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

export const buildPersonalProfileRows = (): PersonalProfileRows[] => [
  {
    label: vp.PersonalProfileLabel.FullName,
    id: vp.PersonalProfileId.FullName,
    required: true,
    preset: 'text',
  },
  {
    label: vp.PersonalProfileLabel.EmailAddress,
    id: vp.PersonalProfileId.EmailAddress,
    required: true,
    preset: 'text',
  },
  {
    label: vp.PersonalProfileLabel.PhoneNumber,
    id: vp.PersonalProfileId.PhoneNumber,
    required: false,
    preset: 'text',
  },
  {
    label: vp.PersonalProfileLabel.Address,
    id: vp.PersonalProfileId.Address,
    required: false,
    preset: 'text',
  },
];

export const buildPersonalProfilePWRows = (): PersonalProfileRows[] => [
  {
    label: vp.PersonalProfileLabel.Password,
    id: vp.PersonalProfileId.Password,
    required: true,
    preset: 'text',
  },
  {
    label: vp.PersonalProfileLabel.ConfirmPassword,
    id: vp.PersonalProfileId.ConfirmPassword,
    required: true,
    preset: 'text',
  },
];
